export const typeLocalization = {
    UK: 'uk',
    EN: 'en',
};
